var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallCenterListIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.34375,
    y: 7.89062,
    width: 25.7812,
    height: 24.2188,
    fill: "#130D38"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5V35C0 36.3261 0.526784 37.5979 1.46447 38.5355C2.40215 39.4732 3.67392 40 5 40H28.75C29.0815 40 29.3995 39.8683 29.6339 39.6339C29.8683 39.3995 30 39.0815 30 38.75C30 38.4185 29.8683 38.1005 29.6339 37.8661C29.3995 37.6317 29.0815 37.5 28.75 37.5H5C4.33696 37.5 3.70107 37.2366 3.23223 36.7678C2.76339 36.2989 2.5 35.663 2.5 35H27.5C28.163 35 28.7989 34.7366 29.2678 34.2678C29.7366 33.7989 30 33.163 30 32.5V5C30 3.67392 29.4732 2.40215 28.5355 1.46447C27.5979 0.526784 26.3261 0 25 0H5ZM15 27.5C9.6425 27.5 7.5 25.155 7.5 22.8125C7.5 21.26 8.94 20 10.715 20H19.285C21.06 20 22.5 21.26 22.5 22.8125C22.5 25.1475 20.3575 27.5 15 27.5ZM18.75 13.75C18.75 14.7446 18.3549 15.6984 17.6517 16.4017C16.9484 17.1049 15.9946 17.5 15 17.5C14.0054 17.5 13.0516 17.1049 12.3484 16.4017C11.6451 15.6984 11.25 14.7446 11.25 13.75C11.25 12.7554 11.6451 11.8016 12.3484 11.0983C13.0516 10.3951 14.0054 10 15 10C15.9946 10 16.9484 10.3951 17.6517 11.0983C18.3549 11.8016 18.75 12.7554 18.75 13.75Z",
    fill: "#E7E7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallCenterListIcon2);
export default __webpack_public_path__ + "static/media/call-center-list-icon-2.cc24435623bb4991af37caee4ffb2846.svg";
export { ForwardRef as ReactComponent };